export const ExecutionStatusList = [
    'canceled',
    'crashed',
    'error',
    'new',
    'running',
    'success',
    'unknown',
    'waiting',
];
export const TERMINAL_EXECUTION_STATUSES = ['canceled', 'crashed', 'error', 'success'];
export function isTerminalExecutionStatus(status) {
    return (status === 'canceled' || status === 'crashed' || status === 'error' || status === 'success');
}
//# sourceMappingURL=execution-status.js.map